import script from "./MappingsCell.vue?vue&type=script&setup=true&lang=js"
export * from "./MappingsCell.vue?vue&type=script&setup=true&lang=js"

import "./MappingsCell.vue?vue&type=style&index=0&id=7480acb8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7480acb8"]])

export default __exports__